module.exports = __webpack_public_path__ + "img/user10.f01708b9.jpg";